import React from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CompanyOverview from './components/CompanyOverview';
import Mission from './components/Mission';
import History from './components/History';
import Leadership from './components/Leadership';
import Facilities from './components/Facilities';
import Certifications from './components/Certifications';
import Values from './components/Values';
import Careers from './components/Careers';

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://www.hi-tak.co.jp/wp-content/uploads/2022/12/image.png"
            alt="HI-TAK Facility"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">About HI-TAK</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Precision Gun Drilling Machine Manufacturer & Deep Hole Processing Specialist
          </p>
        </div>
      </section>

      <CompanyOverview />
      <Mission />
      <History />
      <Leadership />
      <Facilities />
      <Certifications />
      <Values />
      <Careers />
      <Footer />
    </div>
  );
};

export default AboutPage;
